import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import { siteinfos } from "../../../cms/data/settings";
import styled from "styled-components";
import colors from "../../../theme/colors";
import { Box } from "rebass/styled-components";

const MapWrapper = styled.div`
  width: 100%;
  height: 350px;

  #contact-map-wrapper {
    width: 100%;
    height: 100%;
    #contact-map {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .mapboxgl-control-container {
    display: none;
  }
  .mapboxgl-canvas {
    position: inherit;
  }
`;

const Map = ({ position, style }) => {
  // console.log(position);
  style = style || "streets-v11";
  position = JSON.parse(position);
  const mapSettings = {
    apiKey: siteinfos.mapboxtoken,
    map: {
      center: position.coordinates,
      offset: [0, 0], //h,v
      style: "mapbox://styles/mapbox/"+style,
      zoom: 14,
      scrollZoom: false,
      interactive: false
    }
  };

  const mapContainer = useRef(null);
  const [map, setMap] = useState(false);

  var customMarker = document.createElement('div');
  var customMarkerInner = document.createElement('div');
  customMarker.className = 'customMarker';
  customMarker.appendChild(customMarkerInner);
  var markerImg = document.createElement("img");
  markerImg.src = "/img/logo-amb.png";
  customMarkerInner.appendChild(markerImg);

  const markerStyle = {
    ".customMarker": {
      "& > div": {
        p:2,
        bg: "white",
        boxShadow: "header",
        transform: "translateY(-50%)",
        mt: "-8px",
        "&:after": {
          content: "''",
          width: 0, 
          height: 0, 
          borderLeft: "8px solid transparent",
          borderRight: "8px solid transparent",        
          borderTop: "8px solid white",
          position: "absolute",
          top: "100%",
          left: "50%",
          transform: "translateX(-50%)",
          mt: "-1px"
        },
        "img": {
          maxWidth: "100px",
          display: "block"
        }
      }
    }
  }

  useEffect(() => {
    const initializeMap = ({ setMap, mapContainer }) => {
      const mapboxgl = require("mapbox-gl");
      mapboxgl.accessToken = mapSettings.apiKey;
      const map = new mapboxgl.Map({ container: mapContainer.current, ...mapSettings.map });
      map.flyTo({
        center: mapSettings.map.center,
        zoom: mapSettings.map.zoom,
        offset: window.innerWidth >= 10 ? mapSettings.map.offset : [0, 0],
        maxDuration: 1
      });
      // new mapboxgl.Marker({
      //   color: colors.primary
      // }).setLngLat(mapSettings.map.center).addTo(map);
      new mapboxgl.Marker(customMarker).setLngLat(mapSettings.map.center).addTo(map);
      window.onresize = function() {
        map.flyTo({
          center: mapSettings.map.center,
          zoom: mapSettings.map.zoom,
          offset: window.innerWidth >= 10 ? mapSettings.map.offset : [0, 0],
          maxDuration: 1
        });
      };
      map.on("load", () => {
        setMap(map);
        map.resize();
      });
    };

    if (!map) initializeMap({ setMap, mapContainer });
  }, [map]);

  return (
    <MapWrapper>
      <Box id="contact-map-wrapper" sx={markerStyle}>
        <div ref={el => (mapContainer.current = el)} id="contact-map" />
      </Box>
    </MapWrapper>
  );
};

Map.propTypes = {
  position: PropTypes.any
};

export default Map;
